export default "__VITE_ASSET__CSmrN3xV__"